
import React from 'react';
import { FaFacebookSquare, FaGithub, FaGlobe, FaGoogle, FaHome, FaInstagram, FaLinkedin, FaSpotify,   FaTwitter, FaWhatsapp, FaYoutube } from 'react-icons/fa';
 
import { IconSet, TextMessage, Icon } from './styles';
import { useConfiguration } from 'src/hooks/Configuration';
interface IIcons {
    message?: string;
    showText?: boolean;
    backgroundFill?: boolean;
    socialIcons?: Record<string, any>;
    color : string;
    size : string;
  }
  
  const SocialShareSpeaker: React.FC<IIcons> = ({
    message = '',
    showText = false,
    color = '#fff',
    size = '20',
    socialIcons = {}
  }) => {

    const { configuration} = useConfiguration();

 
    const IconItem = ({ title, url, IconItem}) => {

return <Icon
                target="_blank"
                extend={false}
                
                title={title}
                href={url}
                background={'none'}
              >
                <IconItem size={size} color={color}/> 
               </Icon>

    }

    const keys = Object.keys(socialIcons);


    const valids = {

   
       facebook : (url) => <IconItem url={url} title={'Facebook'} IconItem={FaFacebookSquare}/>,
       spotify : (url) => <IconItem url={url} title={'Spotify'} IconItem={FaSpotify}/>, 
       instagram : (url) => <IconItem url={url} title={'Instagram'} IconItem={FaInstagram}/>,
       linkedin : (url) => <IconItem url={url} title={'Linkedin'} IconItem={FaLinkedin}/>,
       github : (url) => <IconItem url={url} title={'Github'} IconItem={FaGithub}/>,
       whatsapp : (url) => <IconItem url={url} title={'Whatsapp'} IconItem={FaWhatsapp}/>,
       website : (url) => <IconItem url={url} title={'Website'} IconItem={FaGlobe}/>,
    }




    return (<> 
      {keys?.length > 0 && (
        <IconSet column={showText}>
         
          <div className="iconSet">
            {keys?.map(key => {

              return valids?.[key] ? valids?.[key](socialIcons?.[key]) : <></>


            })}
          </div>
        </IconSet>)}
      </>
    );
  };

  export default SocialShareSpeaker;